import { render, staticRenderFns } from "./ClassPortraitManage.vue?vue&type=template&id=d74e2db0&scoped=true"
import script from "./ClassPortraitManage.vue?vue&type=script&lang=js"
export * from "./ClassPortraitManage.vue?vue&type=script&lang=js"
import style0 from "./ClassPortraitManage.vue?vue&type=style&index=0&id=d74e2db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74e2db0",
  null
  
)

export default component.exports